import { css } from '@emotion/react';
import { faMessageSmile } from '@fortawesome/pro-solid-svg-icons';
import { type FC } from 'react';
import { getRoundButtonSizePx } from '~/_shared/baseComponents/buttons';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons/roundButton/roundButton.component';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import { type Theme } from '~/_shared/themes/theme.model';
import { useIntercom } from '~/_shared/utils/3rdPartyIntegrations/intercom/intercom.context';
import { GOOGLE_LOGO_SAFE_BOTTOM_OFFSET_PX } from '~/map/mapToolControls/mapOffsets.constants';

const SAFETY_GAP = 8;
export const CHAT_BUTTON_SIZE = RoundButtonSize.Medium;
export const CHAT_BUTTON_SAFE_BOTTOM_OFFSET_PX = GOOGLE_LOGO_SAFE_BOTTOM_OFFSET_PX + getRoundButtonSizePx(CHAT_BUTTON_SIZE) + SAFETY_GAP;

const boxShadowOverride = css({
  boxShadow: 'none',
});

const chatButtonWrapperStyle = (theme: Theme) => css({
  alignSelf: 'flex-start',
  borderRadius: '50%',
  boxShadow: `0px 2px 15px ${theme.shadowColors.primary}`,
});

export const ChatButtonComponent: FC = () => {
  const { isBooted, show: showIntercom } = useIntercom();

  return (
    <div css={chatButtonWrapperStyle}>
      <RoundButtonComponent
        buttonStyle={isBooted ? RoundButtonStyle.Quaternary : RoundButtonStyle.Disabled}
        css={boxShadowOverride}
        icon={faMessageSmile}
        isDisabled={!isBooted}
        onClick={showIntercom}
        size={CHAT_BUTTON_SIZE}
      />
    </div>
  );
};
